import template from './recommended-flyout.html';
export var RecommendedFlyoutComponent = {
    template: template,
    bindings: {
        item: '<'
    }
};
//# sourceMappingURL=recommended-flyout.component.js.map